import { Button } from "@msuite/ui/button";
import { Icon } from "@msuite/ui/icons";
import { createStandardMenuItems, Menu } from "@msuite/ui/menu";
import type { Tables } from "@msuite/utils/types";
import { PartnerTimelineAssignmentReferenceApproveButton } from "./partner-timeline-assignment-reference-approve-button";

/** Props Interface */
interface PartnerTimelineAssignmentReferenceServiceCalculationMenuProps {
	referenceId: string;
	partnershipId: string;
	reference: Tables<"ticketAssignmentReferences">;
	hostOrgId: string;
	handleOnOpen: () => void;
	handleOnEdit: () => void;
	handleOnDelete: () => void;
}

export function PartnerTimelineAssignmentReferenceServiceCalculationMenu({
	handleOnOpen,
	handleOnEdit,
	handleOnDelete,
	reference,
	partnershipId,
	hostOrgId,
}: PartnerTimelineAssignmentReferenceServiceCalculationMenuProps) {
	/** Render */
	return (
		<div className="h-stack gap-4">
			<Menu
				items={createStandardMenuItems({
					onOpen: handleOnOpen,
					onEdit: handleOnEdit,
					onDelete: handleOnDelete,
				})}
			>
				<Button
					icon={<Icon name="EllipsisVertical" />}
					size="xxs"
					variant="white"
					className="-my-1"
				/>
			</Menu>
			<PartnerTimelineAssignmentReferenceApproveButton
				reference={reference}
				partnershipId={partnershipId}
				hostOrgId={hostOrgId}
				hasBookings
			/>
		</div>
	);
}
